import { useState } from "react";
import AuditPromptCard from "../../../components/ui/containers/AuditPromptCard";
import AuditTitleButton from "../../../components/ui/buttons/AuditTitleButton";
import styles from "./FormPrompt.module.css";

const QuestionSection = ({ children, title }) => {
  const [showQuestions, setShowQuestions] = useState(false);

  const titleButtonHandler = (event) => {
    event.preventDefault();
    setShowQuestions(showQuestions ? false : true);
  };

  let childrenClass = showQuestions
    ? styles.questionsDivShow
    : styles.questionsDivHide;

  return (
    <AuditPromptCard>
      <AuditTitleButton
        text={title}
        showQuestions={showQuestions}
        onClickHandler={titleButtonHandler}
      />
      <div className={childrenClass}>{children}</div>
    </AuditPromptCard>
  );
};

export default QuestionSection;
